import React from 'react';
import { OrganizationLabel } from './OrganizationLabel';
import { OrganizationCard } from './OrganizationCard';
import { OrganizationBadge } from './OrganizationBadge';
export var Organization = function Organization(_ref) {
  var entity = _ref.entity,
    variant = _ref.variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 0 : _ref$size,
    role = _ref.role,
    onAction = _ref.onAction,
    _ref$withLink = _ref.withLink,
    withLink = _ref$withLink === void 0 ? true : _ref$withLink;
  switch (variant) {
    case 'label':
      {
        return React.createElement(OrganizationLabel, {
          entity: entity
        });
      }
    case 'card':
      {
        return React.createElement(OrganizationCard, {
          entity: entity,
          role: role,
          onAction: onAction
        });
      }
    case 'badge':
      {
        return React.createElement(OrganizationBadge, {
          entity: entity,
          size: size,
          withLink: withLink
        });
      }
    default:
      return null;
  }
};